var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUwalk4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 114,
    viewBox: "0 0 115 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_390_4221)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 12,
    width: 87,
    height: 87,
    rx: 3.40448,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.2387 79.2899C50.9176 79.072 59.0531 84.9731 64.6806 84.8667C70.3081 84.7603 82.0698 81.3031 81.5851 55.4119C81.1004 29.5207 65.1282 26.0179 58.9366 26.1327C29.9496 26.6749 18.5527 79.6767 39.2387 79.2899Z",
    fill: "url(#paint0_linear_390_4221)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.709 75.8447H28.3311V74.1558H31.709V75.8447Z",
    fill: "#D4D8FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4209 75.8447H38.0431V74.1558H41.4209V75.8447Z",
    fill: "#D4D8FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5107 81.7549H33.8218V78.377H35.5107V81.7549Z",
    fill: "#D4D8FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5107 72.0439H33.8218V68.6661H35.5107V72.0439Z",
    fill: "#D4D8FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M84.1326 33.6227C85.5294 33.6227 86.666 34.7593 86.666 36.1561C86.666 37.5528 85.5294 38.6895 84.1326 38.6895C82.7359 38.6895 81.5992 37.5528 81.5992 36.1561C81.5992 34.7593 82.7359 33.6227 84.1326 33.6227ZM84.1326 37.0005C84.5988 37.0005 84.9771 36.6205 84.9771 36.1561C84.9771 35.6916 84.5988 35.3116 84.1326 35.3116C83.6665 35.3116 83.2882 35.6916 83.2882 36.1561C83.2882 36.6205 83.6665 37.0005 84.1326 37.0005Z",
    fill: "#D4D8FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3445 38.6899V56.4236C70.3445 57.8221 69.2095 58.957 67.8111 58.957H71.6111C73.0096 58.957 74.1445 57.8221 74.1445 56.4236V38.6899C74.1445 37.2915 73.0096 36.1566 71.6111 36.1566H67.8111C69.2095 36.1566 70.3445 37.2915 70.3445 38.6899Z",
    fill: "#F7F7F8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9777 79.8793C60.8392 79.8793 55.0312 74.0713 55.0312 66.9328C55.0312 59.7943 60.8392 53.9863 67.9777 53.9863C75.1162 53.9863 80.9242 59.7943 80.9242 66.9328C80.9242 74.0713 75.1162 79.8793 67.9777 79.8793ZM67.9777 56.974C62.4864 56.974 58.0189 61.4415 58.0189 66.9328C58.0189 72.4241 62.4864 76.8916 67.9777 76.8916C73.469 76.8916 77.9365 72.4241 77.9365 66.9328C77.9365 61.4415 73.469 56.974 67.9777 56.974Z",
    fill: "#433ED1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1787 56.9746H54.2529V59.9623H43.1787V56.9746Z",
    fill: "#433ED1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1787 49.0068H63.1163V51.9945H43.1787V49.0068Z",
    fill: "#433ED1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1855 41.041H64.9894V44.0287H43.1855V41.041Z",
    fill: "#433ED1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0921 68.5105H37.1045V39.5463C37.1045 35.4273 40.4546 32.0771 44.5736 32.0771H74.4501V35.0648H44.5736C42.1018 35.0648 40.0921 37.0745 40.0921 39.5463V68.5105Z",
    fill: "#433ED1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4292 43.0318H69.4704C68.6458 43.0318 67.9766 42.3626 67.9766 41.538V38.5504C67.9766 34.9811 70.8806 32.0771 74.4498 32.0771C78.019 32.0771 80.923 34.9811 80.923 38.5504V41.538C80.923 42.3626 80.2538 43.0318 79.4292 43.0318ZM70.9642 40.0442H77.9354V38.5504C77.9354 36.6283 76.3718 35.0648 74.4498 35.0648C72.5277 35.0648 70.9642 36.6283 70.9642 38.5504V40.0442Z",
    fill: "#433ED1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8712 79.8785H38.5984C35.5769 79.8785 33.1211 77.4227 33.1211 74.4012V68.5055C33.1211 67.681 33.7903 67.0117 34.6149 67.0117H50.6287V69.9994H36.1087V74.4012C36.1087 75.7735 37.2261 76.8909 38.5984 76.8909H54.8712V79.8785Z",
    fill: "#433ED1"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9766 41.5371H70.9642V49.5838H67.9766V41.5371Z",
    fill: "#433ED1"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.0095 69.8922C69.7828 69.8922 71.2203 68.4547 71.2203 66.6814C71.2203 64.9082 69.7828 63.4706 68.0095 63.4706C66.2363 63.4706 64.7988 64.9082 64.7988 66.6814C64.7988 68.4547 66.2363 69.8922 68.0095 69.8922ZM68.0095 72.3121C71.1193 72.3121 73.6402 69.7911 73.6402 66.6814C73.6402 63.5717 71.1193 61.0508 68.0095 61.0508C64.8998 61.0508 62.3789 63.5717 62.3789 66.6814C62.3789 69.7911 64.8998 72.3121 68.0095 72.3121Z",
    fill: "#433ED1"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.2231 72.7087L68.1779 69.0553L69.7999 67.2594L73.8451 70.9129L72.2231 72.7087Z",
    fill: "#433ED1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_390_4221",
    x: 0.722534,
    y: 0.0843256,
    width: 113.555,
    height: 113.555,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.36179
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.63873
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_390_4221"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_390_4221",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_390_4221",
    x1: 55.1436,
    y1: 84.8682,
    x2: 55.1436,
    y2: 26.1301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F2FF",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUwalk4);
export default __webpack_public_path__ + "static/media/uwalk4.7179b81d2470d84767be941a8f943059.svg";
export { ForwardRef as ReactComponent };